import React from 'react';

import Layout from './Layout.jsx';
import Functionalities from './Functionalities.jsx';
import Footer from './Footer.jsx';
import ChatSteps from './ChatSteps.jsx';
import Navbar from './Navbar.jsx';
import { useMenuItems } from './menuItems.jsx';
import PricingPage from './PricingPage.jsx';
import CTASection from './CTASection.jsx';

const LandingPage = () => {
    const {
        menuItems,
        layoutRef,
        functionalitiesRef,
        purchasesRef,
        contactUsRef,
        chatStepsRef,
        footerRef,
    } = useMenuItems();

    return (
        <div className='font-sans antialiased bg-landing-white'>
            <Navbar menuItems={menuItems} />
            <Layout ref={layoutRef} />
            <Functionalities ref={functionalitiesRef} />
            <ChatSteps ref={chatStepsRef} />
            <PricingPage ref={purchasesRef} />
            <CTASection ref={contactUsRef} />
            <Footer ref={footerRef} />
        </div>
    );
};

export default LandingPage;
